//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('jobQueueMonitor', {
//        templateUrl: 'views/components/views/jobQueueMonitor/jobQueueMonitor.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['jobQueueMonitorService', function (jobQueueMonitorService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                setting: {},
//                updatingJobQueue: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await jobQueueMonitorService.getSetting())[0];

//                vm.model.updatingJobQueue = false;
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON REFRESH FUNCTION

//            vm.updateJobQueue = function () {
//                vm.model.updatingJobQueue = true;
//                loadSetting();
//            }

//            // #endregion BUTTON REFRESH FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadSetting();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
